module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material-input-holder",
    class: _vm.parentClass
  }, [(_vm.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueMutatedStr),
      expression: "valueMutatedStr"
    }],
    staticClass: "material-input",
    class: _vm.labelClass,
    attrs: {
      "type": "text",
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.valueMutatedStr)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueMutatedStr = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueMutatedStr),
      expression: "valueMutatedStr"
    }],
    staticClass: "material-input",
    class: _vm.labelClass,
    attrs: {
      "type": "email",
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.valueMutatedStr)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueMutatedStr = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueMutatedStr),
      expression: "valueMutatedStr"
    }],
    staticClass: "material-input",
    class: _vm.labelClass,
    attrs: {
      "type": "password",
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.valueMutatedStr)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueMutatedStr = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueMutatedNumber),
      expression: "valueMutatedNumber"
    }],
    staticClass: "material-input",
    class: _vm.labelClass,
    attrs: {
      "type": "number",
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.valueMutatedNumber)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueMutatedNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "material-input-label",
    class: _vm.labelClass,
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4df918af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/InputMaterial.vue
// module id = 244
// module chunks = 1